"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheToggleGroup = void 0;

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

var _react = _interopRequireDefault(require("react"));

var _clsx3 = _interopRequireDefault(require("clsx"));

var _toggleGroup = require("./toggle-group.business");

var _toggleGroup2 = require("./toggle-group.style");

var _core = require("../core");

var _excluded = ["children", "className", "classes", "elevation", "exclusive", "onChange", "value", "disabled", "rounded"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The RocheToggleGroup will control the selected of its child buttons when given its own
 * value property
 */
var RocheToggleGroup = function RocheToggleGroup(props) {
  var _clsx2;

  var childrenProp = props.children,
      className = props.className,
      classes = props.classes,
      elevation = props.elevation,
      exclusive = props.exclusive,
      onChange = props.onChange,
      value = props.value,
      disabled = props.disabled,
      rounded = props.rounded,
      other = _objectWithoutProperties(props, _excluded);

  var innerClasses = (0, _toggleGroup2.useStyles)({
    classes: classes,
    elevation: elevation
  });

  var handleChange = function handleChange(event, buttonValue) {
    if (!onChange) return;
    var index = value && value.indexOf(buttonValue);
    var newValue = value ? index >= 0 ? _toConsumableArray(value).filter(function (val, i) {
      return i !== index;
    }) : [].concat(_toConsumableArray(value), [buttonValue]) : [buttonValue];
    onChange(event, newValue);
  };

  var handleExclusiveChange = function handleExclusiveChange(event, buttonValue) {
    if (!onChange) return;
    onChange(event, value === buttonValue ? null : buttonValue);
  };

  var children = _react["default"].Children.map(childrenProp, function (child) {
    var _child$props$classes;

    if (! /*#__PURE__*/_react["default"].isValidElement(child)) {
      return null;
    }

    var _child$props = child.props,
        valueChildProp = _child$props.value,
        selectedChildProp = _child$props.selected,
        disabledChildProp = _child$props.disabled;
    var selectedChild = selectedChildProp === undefined ? (0, _toggleGroup.isValueSelected)(valueChildProp, value) : selectedChildProp;
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      elevation: elevation,
      selected: selectedChild,
      disabled: disabled ? disabled : disabledChildProp,
      value: valueChildProp,
      classes: _objectSpread(_objectSpread({}, child.props.classes), {}, {
        selected: (0, _clsx3["default"])((_child$props$classes = child.props.classes) === null || _child$props$classes === void 0 ? void 0 : _child$props$classes.selected, _defineProperty({}, innerClasses.selected, selectedChild))
      }),
      onClick: exclusive ? handleExclusiveChange : handleChange
    });
  });

  var rootClasses = (0, _clsx3["default"])(innerClasses.root, (_clsx2 = {}, _defineProperty(_clsx2, innerClasses.rounded, rounded), _defineProperty(_clsx2, innerClasses.disabled, disabled), _clsx2), className);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: rootClasses
  }, other), children);
};

exports.RocheToggleGroup = RocheToggleGroup;
RocheToggleGroup.displayName = (0, _core.rochePrefix)('ToggleGroup');
RocheToggleGroup.defaultProps = {
  elevation: 2,
  exclusive: false
};
var _default = RocheToggleGroup;
exports["default"] = _default;